import { c as _c } from "react/compiler-runtime";
import { alpha } from '@classify/react-core-components/styles';
import Button, { Props } from '@classify/react-core-components/Button';
interface CategoryButtonProps extends Props {
  categoryColor: string | undefined;
}
const CategoryButton = t0 => {
  const $ = _c(17);
  let children;
  let otherProps;
  let sx;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      categoryColor: t1,
      sx,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = otherProps;
    $[3] = sx;
    $[4] = t1;
  } else {
    children = $[1];
    otherProps = $[2];
    sx = $[3];
    t1 = $[4];
  }
  const categoryColor = t1 === undefined ? "initial" : t1;
  const t2 = `${categoryColor} !important`;
  let t3;
  if ($[5] !== categoryColor) {
    t3 = alpha(categoryColor, 0.8);
    $[5] = categoryColor;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `${t3} !important`;
  let t5;
  if ($[7] !== t4) {
    t5 = {
      background: t4
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== sx || $[10] !== t2 || $[11] !== t5) {
    t6 = {
      background: t2,
      "&:hover": t5,
      ...sx
    };
    $[9] = sx;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== children || $[14] !== otherProps || $[15] !== t6) {
    t7 = <Button sx={t6} {...otherProps}>{children}</Button>;
    $[13] = children;
    $[14] = otherProps;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default CategoryButton;